function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// @mui imports
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { styled } from "@mui/material/styles";
// Limitless imports
import Grid from "../../layout/Grid";
import Typography from "../../data-display/typography/Typography";
import Badge from "../../feedback/badge/Badge";
const TabAccordion = styled(Accordion)(() => ({
  "&:before": {
    backgroundColor: "transparent !important"
  },
  boxShadow: "none !important",
  borderRadius: "0px !important",
  marginBottom: "10px",
  backgroundColor: "transparent",
  backgroundImage: "none"
}));
const TabAccordionSummary = styled(AccordionSummary)(() => ({
  "& .MuiAccordionSummary-content": {
    margin: "0px !important"
  },
  padding: "0px 0px 0px 24px",
  width: "fit-content",
  whiteSpace: "break-spaces"
}));
const VerticalTabContent = styled(Tab)(() => ({
  textTransform: "none",
  alignItems: "flex-start",
  paddingLeft: theme => theme.spacing(3),
  color: theme => theme.palette.primary.dark
}));
const VerticalTab = ({
  id = "vertical-tab-default-id",
  items,
  children,
  handleSubCategoryChange,
  ...rest
}) => {
  const [selectedSubTabIndex, setSelectedSubTabIndex] = React.useState(null);
  const onSubTabChange = (e, categoryIndex, tabIndex) => {
    setSelectedSubTabIndex(categoryIndex);
    if (handleSubCategoryChange) {
      handleSubCategoryChange(categoryIndex, tabIndex);
    }
  };
  React.useEffect(() => {
    if (selectedSubTabIndex !== null) {
      setSelectedSubTabIndex(null);
    }
  }, [rest.value]);
  const renderTabContent = (item, index) => {
    const TabContent = /*#__PURE__*/React.forwardRef((props, ref) => {
      var _item$category, _item$category2;
      const accordianProps = {
        ...props
      };
      delete accordianProps.className;
      return /*#__PURE__*/React.createElement(TabAccordion, _extends({
        disableGutters: true
      }, accordianProps, {
        expanded: ((_item$category = item.category) === null || _item$category === void 0 ? void 0 : _item$category.length) > 0 && rest.value === index
      }), /*#__PURE__*/React.createElement(TabAccordionSummary, {
        "aria-controls": "panel1a-content",
        id: "panel1a-header"
      }, /*#__PURE__*/React.createElement(Badge, {
        content: /*#__PURE__*/React.createElement(Typography, {
          variant: "subtitle1",
          sx: {
            color: theme => rest.value === index ? theme.palette.primary.main : theme.palette.primary.dark,
            width: 182,
            textAlign: "left"
          },
          mr: 1.5
        }, item === null || item === void 0 ? void 0 : item.label),
        count: item.badgeCount,
        variant: "standard",
        name: "unreadMessageCount",
        badgeContent: item.badgeContent
      })), ((_item$category2 = item.category) === null || _item$category2 === void 0 ? void 0 : _item$category2.length) > 0 && /*#__PURE__*/React.createElement(AccordionDetails, {
        sx: {
          padding: "0px 16px 0px 16px"
        }
      }, /*#__PURE__*/React.createElement(Tabs, {
        orientation: "vertical",
        onChange: (e, categoryIndex) => onSubTabChange(e, categoryIndex, index),
        value: selectedSubTabIndex ? selectedSubTabIndex : false,
        TabIndicatorProps: {
          sx: {
            left: 0,
            height: "0px !important"
          }
        }
      }, item.category.map((categoryItem, categoryIndex) => /*#__PURE__*/React.createElement(VerticalTabContent, {
        sx: {
          padding: "10px 14px",
          minHeight: "44px"
        },
        key: categoryIndex,
        value: categoryIndex,
        label: /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          sx: selectedSubTabIndex === categoryIndex ? {
            color: theme => theme.palette.primary.main
          } : {
            color: theme => theme.palette.primary.dark
          }
        }, categoryItem),
        disableRipple: true
      })))));
    });
    TabContent.displayName = "TabContent";
    return TabContent;
  };
  return /*#__PURE__*/React.createElement(Grid, {
    sx: {
      width: 285,
      padding: "40px 23px 40px 48px"
    }
  }, children, /*#__PURE__*/React.createElement(Tabs, _extends({
    id: id,
    orientation: "vertical",
    TabIndicatorProps: rest.value === false ? {} : {
      sx: {
        left: 0,
        marginTop: "10px",
        height: "28px !important"
      }
    },
    sx: {
      paddingLeft: 1,
      paddingRight: 1
    }
  }, rest), items.map((item, index) => /*#__PURE__*/React.createElement(VerticalTabContent, {
    key: index,
    value: index,
    disableRipple: true,
    component: renderTabContent(item, index)
  }))));
};
VerticalTab.propTypes = {
  id: PropTypes.string,
  items: PropTypes.array.isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  handleSubCategoryChange: PropTypes.func
};
export default VerticalTab;